import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <div className="eyebrow">FAQ</div>
          <h2 className="font-serif-display mt-4 text-4xl md:text-6xl leading-[1.05] tracking-tight text-[#111]">
            <span className="italic text-[#C8A44D]">Answers,</span> before you ask.
          </h2>
          <p className="mt-6 text-[#555] font-light leading-relaxed max-w-sm">
          Have something else on your mind? Call or text us anytime &mdash; we&apos;re
            happy to help.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#111]/12"
              >
                <AccordionTrigger className="text-left py-6 hover:no-underline">
                  <span className="font-serif-display text-xl md:text-2xl tracking-tight text-[#111] pr-6">
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#555] font-light leading-relaxed pb-7 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
